(ns app.dashboard.events
  (:require [ajax.core :as ajax]
            [app.endpoints :as endpoints :refer [add-folder-endpoint
                                                 add-folder-endpoint
                                                 delete-folder-endpoint delete-form-endpoint delete-product-endpoint duplicate-form-endpoint
                                                 duplicate-product-endpoint folders-endpoint get-forms-endpoint get-products-endpoint
                                                 get-workspace-forms-endpoint get-workspace-products-endpoint move-form-endpoint
                                                 move-product-endpoint restore-folder-endpoint strive-react-endpoint
                                                 reorder-workspaces-endpoint update-folder-name-endpoint update-form-name update-product-name
                                                 copy-product-endpoint copy-form-endpoint  deleted-assets-endpoint
                                                 empty-trash-endpoint restore-assets-endpoint delete-assets-permanently-endpoint
                                                 get-recent-endpoint get-statistics-data-endpoint check-folder-status-endpoint
                                                 move-multiple-endpoint copy-multiple-endpoint delete-assets-to-trash-endpoint
                                                 get-recent-endpoint get-statistics-data-endpoint get-statistics-folder-data-endpoint
                                                 check-folder-status-endpoint]]

            [day8.re-frame.http-fx]
            [day8.re-frame.tracing :refer-macros [fn-traced]]
            [re-frame.core :refer [reg-event-db reg-event-fx]]
            [re-posh.core :refer [dispatch reg-event-ds reg-sub subscribe]]))


;;TODO change id to meaningful


(reg-event-ds
 ::add-workspaces
 (fn-traced [_ [_ val]]
            [[:db/add 2 :workspace/data val]]))

(defn keywordize-id
  [coll]
  (dispatch [::add-workspaces coll]))

(reg-event-ds
 ::add-selected-workspace
 (fn-traced [_ [_ val]]
            [[:db/add 1 :selected-workspace/id (:selected-workspace/id  val)]
             [:db/add 1 :selected-workspace/name (:selected-workspace/name val)]]))

(reg-event-ds
 ::add-selected-folder
 (fn-traced [_ [_ val]]
            [[:db/add 3 :selected-folder/id (:selected-folder/id  val)]
             [:db/add 3 :selected-folder/name (:selected-folder/name val)] 
             [:db/add 3 :selected-folder/new (:selected-folder/new val)]]))

(reg-event-ds
 ::add-selected-folder-order
 (fn-traced [_ [_ val]]
            [[:db/add 3 :selected-folder/order (:selected-folder/order val)]]))

(reg-event-ds
 ::add-restored-folder
 (fn-traced [_ [_ val]]
            [[:db/add 14 :restored-folder/id (:restored-folder/id  val)]]))

(reg-event-ds
 ::add-selected-folder-status
 (fn-traced [_ [_ val]]
            [[:db/add 3 :selected-folder/is_active (:selected-folder/is_active  val)]
             [:db/add 3 :selected-folder/deleted_from_trash (:selected-folder/deleted_from_trash val)]]))

(reg-event-ds
 ::add-deleted-selected-folder
 (fn-traced [_ [_ val]]
            [[:db/add 12 :deleted-selected-folder/id (:deleted-selected-folder/id  val)]
             [:db/add 12 :deleted-selected-folder/name (:deleted-selected-folder/name val)]]))

(reg-event-ds
 ::update-folder-new
 (fn-traced [_ [_ val]]
            [[:db/add 3 :selected-folder/new val]]))
(reg-sub
 ::user-token
 (fn [_ _]
   {:type :query
    :query '[:find  ?wid
             :where [?wid :app/type :type/user]]}))

(reg-sub
 ::user-token-id
 :<- [::user-token]
 (fn [id _]
   {:type    :pull
    :pattern '[:db/id :user/token]
    :id       (first (first id))}))

(reg-event-fx
 ::get-all-deleted
 (fn [{:keys [ds]} [_ {:keys [workspace-id folder-id]}]]
   (dispatch [::get-deleted-assets workspace-id])))

(reg-event-fx
 ::get-workspaces
 (fn [{:keys [ds]} _]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :get
                   :uri             endpoints/workspaces-endpoint
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [:get-workspaces-success]
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))



(reg-event-ds
 ::add-folders
 (fn-traced [_ [_ val]]
            [[:db/add 1 :selected-workspace/folders val]]))


(reg-event-ds
 ::add-deleted-assets
 (fn-traced [_ [_ val]]
            [[:db/add 8 :deleted-selected-workspace/assets val]]))

(reg-event-ds
 ::add-projects
 (fn-traced [_ [_ val]]
            [[:db/add 3 :selected-folder/projects val]
             [:db/add 12 :deleted-selected-folder/projects val]]))

(reg-event-ds
 ::add-forms
 (fn-traced [_ [_ val]]
            [[:db/add 3 :selected-folder/forms val]
             [:db/add 12 :deleted-selected-folder/forms val]]))

(reg-event-ds
 ::add-folder-status
 (fn-traced [_ [_ val]]
            [[:db/add 13 :folder-status/status val]]))

(reg-event-ds
 ::add-last-action
 (fn-traced [_ [_ val]]
            [[:db/add 7 :last-action/id val]]))

(reg-event-ds
 ::add-recent-products
 (fn-traced [_ [_ val]]
            [[:db/add 9 :statistics/recent-products val]]))

(reg-event-ds
 ::add-statistics-products
 (fn-traced [_ [_ val]]
            [[:db/add 9 :statistics/statistics-products val]]))

(reg-event-ds
 ::add-statistics-data
 (fn-traced [_ [_ val]]
            [[:db/add 9 :statistics/statistics-data val]]))

(reg-event-ds
 ::add-statistics-folder-data
 (fn-traced [_ [_ val]]
            [[:db/add 9 :statistics/statistics-folder-data val]]))

(reg-event-db
 :get-workspaces-success
 (fn [ds [_ workspaces]]
   (keywordize-id  workspaces)))

(reg-event-fx
 ::update-folder
 (fn [{:keys [_]} [_ {:keys [workspace-folders name index]}]]
   (dispatch [::add-folders (update workspace-folders index #(assoc % :name name))])))

(reg-event-fx
 ::delete-folder-local
 (fn [{:keys [_]} [_ {:keys [workspace-folders folder-id]}]]
   (dispatch [::add-folders (remove #(= (:workspace_id %) folder-id) workspace-folders)])))

(reg-event-fx
 ::reorder-folders
 (fn [{:keys [_]} [_ {:keys [workspace-id new-folder-list]}]]
   (dispatch [::reorder-folders-backend workspace-id new-folder-list])
   (dispatch [::add-folders new-folder-list])))

(reg-event-fx
 ::get-folders
 (fn [{:keys [ds]} [_ workspace-id]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :get
                   :uri           (folders-endpoint workspace-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8080"
                   :on-success      [:get-folders-success workspace-id]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::get-deleted-assets
 (fn [{:keys [ds]} [_ workspace-id]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :get
                   :uri           (deleted-assets-endpoint workspace-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8080"
                   :on-success      [:get-deleted-assets-success workspace-id]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::add-folder
 (fn [{:keys [ds]} [_ workspace-id order]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :post
                   :uri           (add-folder-endpoint workspace-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :params {:name "New Folder"
                            :order order}
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8080"
                   :on-success      [:get-folders-success workspace-id]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::reorder-folders-backend
 (fn [{:keys [ds]} [_ workspace-id list]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :put
                   :uri           (reorder-workspaces-endpoint workspace-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :params {:list list}
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8080"
                   :on-success      [:get-folders-success workspace-id]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::get-projects
 (fn [{:keys [ds]} [_ {:keys [workspace-id folder-id]}]]
   (dispatch [::add-selected-folder {:selected-folder/id folder-id
                                     :selected-folder/name ""
                                 ;;    :selected-folder/order 0 ;;TODO: BUG HERE
                                     :selected-folder/new false}])
   (dispatch [::get-products {:workspace-id workspace-id :folder-id folder-id}])
   (dispatch [::get-forms {:workspace-id workspace-id :folder-id folder-id}])
   (dispatch [::get-workspace-products {:workspace-id workspace-id}])
   (dispatch [::get-workspace-forms {:workspace-id workspace-id}])
   (dispatch [::check-folder-status {:workspace-id workspace-id :folder-id folder-id}])
   (dispatch [::get-statistics-folder-data {:workspace-id workspace-id :folder-id folder-id}])


   ;;to do: creating API
   ))

(reg-event-fx
 ::get-products
 (fn [{:keys [ds]} [_ {:keys [workspace-id folder-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :get
                   :uri    (get-products-endpoint workspace-id folder-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [:get-projects-success]
                   :on-failure      [:endpoint-request-error :get-folders]}})))
(reg-event-fx
 ::get-workspace-products
 (fn [{:keys [ds]} [_ {:keys [workspace-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :get
                   :uri    (get-workspace-products-endpoint workspace-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [:get-workspace-projects-success]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::get-workspace-forms
 (fn [{:keys [ds]} [_ {:keys [workspace-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :get
                   :uri    (get-workspace-forms-endpoint workspace-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [:get-workspace-forms-success]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::get-forms
 (fn [{:keys [ds]} [_ {:keys [workspace-id folder-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :get
                   :uri             (get-forms-endpoint workspace-id folder-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [:get-forms-success]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::check-folder-status
 (fn [{:keys [ds]} [_ {:keys [workspace-id folder-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :get
                   :uri           (check-folder-status-endpoint workspace-id folder-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8080"
                   :on-success      [:get-folder-status-success]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::update-form-name
 (fn [{:keys [ds]} [_ {:keys [form-id name workspace-id folder-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :put
                   :uri             (update-form-name folder-id form-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :params {:name name}
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [::get-forms  workspace-id  folder-id]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::update-form-name-local
 (fn [{:keys [_]} [_ {:keys [forms name index]}]]
   (dispatch [::add-forms (update forms index #(assoc % :name name))])))

(reg-event-fx
 ::delete-form-local
 (fn [{:keys [_]} [_ {:keys [forms form-id]}]]
   (dispatch [::add-forms (remove #(= (:id %) form-id) forms)])))

(reg-event-fx
 ::delete-product-local
 (fn [{:keys [_]} [_ {:keys [products product-id]}]]

   (dispatch [::add-projects (remove #(= (:id %) product-id) products)])))

(reg-event-fx
 ::update-product-name-local
 (fn [{:keys [_]} [_ {:keys [products name index]}]]
   (dispatch [::add-projects (update products index #(assoc % :name name))])))

(reg-event-fx
 ::update-product-name
 (fn [{:keys [ds]} [_ {:keys [product-id name workspace-id folder-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :put
                   :uri             (update-product-name folder-id product-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :params {:name name}
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [::get-products  workspace-id  folder-id]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::create-form
 (fn [{:keys [ds]} [_ {:keys [workspace-id folder-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :post
                   :uri           (get-forms-endpoint workspace-id folder-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8080"
                   :on-success      [:create-new-form-success workspace-id folder-id]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::create-product
 (fn [{:keys [ds]} [_ {:keys [workspace-id folder-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :post
                   :uri           (get-products-endpoint workspace-id folder-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8080"
                   :on-success      [:create-new-product-success workspace-id folder-id]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::update-folder-name
 (fn [_world [_ {:keys [workspace-id folder-id name]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :put
                   :uri              (update-folder-name-endpoint workspace-id folder-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)}
                   :params {:name name}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::get-folders  workspace-id]
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))

(reg-event-fx
 ::delete-folder
 (fn [_world [_ {:keys [workspace-id folder-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :delete
                   :uri              (delete-folder-endpoint workspace-id folder-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8280"
                   :on-success      [::get-folders workspace-id]
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))

(reg-event-fx
 ::empty-trash
 (fn [_world [_ {:keys [workspace-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :delete
                   :uri              (empty-trash-endpoint workspace-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8280"
                   :on-success      [::get-folders  workspace-id]
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))

(reg-event-fx
 ::restore
 (fn [_world [_ {:keys [workspace-id assets-id folder-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :put
                   :uri              (restore-assets-endpoint workspace-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)}
                   :params (cond-> {:assets-id assets-id}
                             folder-id (assoc :folder-id folder-id))
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8280"
                   :on-success      [::get-folders  workspace-id]
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))

(reg-event-fx
 ::delete-multiple
 (fn [_world [_ {:keys [workspace-id folder-id asset-ids]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :delete
                   :uri              (delete-assets-to-trash-endpoint workspace-id folder-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)}
                   :params {:asset-ids asset-ids
                            :folder-id folder-id}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8280"
                   :on-success      [::get-projects workspace-id folder-id]
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))

(reg-event-fx
 ::delete-permanently
 (fn [_world [_ {:keys [workspace-id assets-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :delete
                   :uri              (delete-assets-permanently-endpoint workspace-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)}
                   :params {:assets-id assets-id}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8280"
                   :on-success      [::get-folders  workspace-id]
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))

(reg-event-fx
 ::restore-folder
 (fn [_world [_ {:keys [workspace-id folder-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :put
                   :uri              (restore-folder-endpoint workspace-id folder-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8280"
                   :on-success      [::get-folders  workspace-id]
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))


(reg-event-fx
 ::move-multiple
 (fn [_world [_ {:keys [workspace-id folder-id asset-ids destination-folder-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :put
                   :uri              (move-multiple-endpoint workspace-id folder-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)}
                   :params {:asset-ids asset-ids
                            :destination-folder-id destination-folder-id}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8280"
                   :on-success      [::get-projects workspace-id folder-id]
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))

(reg-event-fx
 ::copy-multiple
 (fn [_world [_ {:keys [workspace-id folder-id asset-ids destination-folder-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :put
                   :uri              (copy-multiple-endpoint workspace-id folder-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)}
                   :params {:asset-ids asset-ids
                            :destination-folder-id destination-folder-id}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8280"
                   :on-success      [::get-folders  workspace-id]
                   :on-failure      [:endpoint-request-error :get-workspaces]}})))



(reg-event-fx
 ::move-product
 (fn [{:keys [ds]} [_ {:keys [workspace-id folder-id product-id destination-folder-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :put
                   :uri             (move-product-endpoint folder-id product-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :params {:destination-folder-id destination-folder-id}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [::get-products {:workspace-id workspace-id :folder-id folder-id}]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::move-form
 (fn [{:keys [ds]} [_ {:keys [workspace-id folder-id form-id destination-folder-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :put
                   :uri             (move-form-endpoint folder-id form-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :params {:destination-folder-id destination-folder-id}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [::get-forms {:workspace-id workspace-id :folder-id folder-id}]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::duplicate-form
 (fn [{:keys [ds]} [_ {:keys [workspace-id folder-id form-id form-id-str name]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :post
                   :uri             (duplicate-form-endpoint workspace-id folder-id form-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :params {:form-id-str form-id-str
                            :name name}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [::get-forms {:workspace-id workspace-id :folder-id folder-id}]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::copy-form
 (fn [{:keys [ds]} [_ {:keys [workspace-id folder-id form-id form-id-str name destination-folder-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :post
                   :uri             (copy-form-endpoint workspace-id folder-id form-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :params {:form-id-str form-id-str
                            :name name
                            :destination-folder-id destination-folder-id}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [::get-forms {:workspace-id workspace-id :folder-id folder-id}]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::delete-form
 (fn [{:keys [ds]} [_ {:keys [workspace-id folder-id form-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :delete
                   :uri             (delete-form-endpoint workspace-id folder-id form-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [::get-forms {:workspace-id workspace-id :folder-id folder-id}]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::delete-product
 (fn [{:keys [ds]} [_ {:keys [workspace-id folder-id product-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :delete
                   :uri             (delete-product-endpoint workspace-id folder-id product-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [::get-products {:workspace-id workspace-id :folder-id folder-id}]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::duplicate-product
 (fn [{:keys [ds]} [_ {:keys [workspace-id folder-id product-id name product-description product-template-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :post
                   :uri             (duplicate-product-endpoint workspace-id folder-id product-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :params {:name name
                            :product-description product-description
                            :product-template-id product-template-id}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [::get-products {:workspace-id workspace-id :folder-id folder-id}]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::copy-product
 (fn [{:keys [ds]} [_ {:keys [workspace-id folder-id product-id name product-description product-template-id destination-folder-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :post
                   :uri             (copy-product-endpoint workspace-id folder-id product-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :params {:name name
                            :product-description product-description
                            :product-template-id product-template-id
                            :destination-folder-id destination-folder-id}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [::get-products {:workspace-id workspace-id :folder-id folder-id}]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-fx
 ::get-recent-products
 (fn [{:keys [ds]} [_ {:keys [workspace-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :get
                   :uri    (get-recent-endpoint workspace-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [:get-recent-products-success]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-db
 :get-recent-products-success
 (fn [ds [_ projects]]
   (dispatch [::add-recent-products projects])))

(reg-event-fx
 ::get-workspace-data
 (fn [{:keys [ds]} [_ {:keys [workspace-id]}]]
   (dispatch [::get-folders workspace-id])
   (dispatch [::get-recent-products {:workspace-id workspace-id}])
   (dispatch [::get-statistics-workspace-data {:workspace-id workspace-id}])))

(reg-event-fx
 ::get-statistics-products
 (fn [{:keys [ds]} [_ {:keys [workspace-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :get
                   :uri    (get-statistics-data-endpoint workspace-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [:get-statistics-products-success]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-db
 :get-statistics-products-success
 (fn [ds [_ projects]]
   (dispatch [::add-statistics-products projects])))

(reg-event-fx
 ::get-statistics-workspace-data
 (fn [{:keys [ds]} [_ {:keys [workspace-id]}]]
   (dispatch [::get-folders workspace-id])
   (dispatch [::get-statistics-products {:workspace-id workspace-id}])
   (dispatch [::get-statistics-data {:workspace-id workspace-id}])
   (dispatch [::get-message-sent {:workspace-id workspace-id}])))

(reg-event-fx
 ::get-statistics-data
 (fn [{:keys [ds]} [_ {:keys [workspace-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :get
                   :uri    (get-statistics-data-endpoint workspace-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [:get-statistics-data-success]
                   :on-failure      [:endpoint-request-error :get-folders]}})))

(reg-event-db
 :get-statistics-data-success
 (fn [ds [_ projects]]
   (dispatch [::add-statistics-data projects])))


(reg-event-fx
 ::get-statistics-folder-data
 (fn [{:keys [ds]} [_ {:keys [workspace-id folder-id]}]]
   (let [{token-id :user/token} @(subscribe [::user-token-id])]
     {:http-xhrio {:method          :get
                   :uri    (get-statistics-folder-data-endpoint workspace-id folder-id)
                   :headers  {"Authorization"  (str "Bearer " token-id)
                              "Cache-Control"  "no-cache"}
                   :mode :cors
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [:get-statistics-folder-data-success]
                   :on-failure      [:endpoint-request-error :get-folders]}})))


(reg-event-db
 :get-statistics-folder-data-success
 (fn [ds [_ projects]]
   (dispatch [::add-statistics-folder-data projects])))


(reg-event-db
 :get-folders-success
 (fn [ds [_ workspace-id folders]]
   (.addRecords (-> js/window .-CommandBar) "workspace-folders" (clj->js (:folders folders))
                (clj->js {:renderOptions {:labelKey "name"}
                          :quickFindOptions {:quickFind true}}))
   (.addMetadata (-> js/window .-CommandBar) "selected-workspace" workspace-id)
   (dispatch [::add-folders (:folders folders)])))

(reg-event-db
 :get-deleted-assets-success
 (fn [ds [_ workspace-id assets]]
   (dispatch [::add-deleted-assets (:assets assets)])))

(reg-event-db
 :get-projects-success
 (fn [ds [_ projects]]
   (dispatch [::add-projects (:projects projects)])))

(reg-event-db
 :get-workspace-projects-success
 (fn [ds [_ projects]]
   (.addRecords (-> js/window .-CommandBar) "projects" (clj->js  projects)
                (clj->js {:renderOptions {:labelKey "name"}
                          :quickFindOptions {:quickFind true}}))))

(reg-event-db
 :get-workspace-forms-success
 (fn [ds [_ projects]]
   (.addRecords (-> js/window .-CommandBar) "forms" (clj->js  projects)
                (clj->js {:renderOptions {:labelKey "name"}
                          :quickFindOptions {:quickFind true}}))))
(reg-event-db
 :get-forms-success
 (fn [ds [_ projects]]
   (dispatch [::add-forms (:projects projects)])))

(reg-event-db
 :get-folder-status-success
 (fn [ds [_ folder-status]]
   (dispatch [::add-folder-status (:folder-status folder-status)])))

(reg-event-db
 :endpoint-request-error
 (fn [ds [_ request-type response]]
   (-> ds
       (assoc-in  [:errors request-type] (get response :status-text))
       (assoc-in  [:loading request-type] false))))

(defn get-token []
  (.getItem (.-localStorage js/window) "token"))

(reg-event-db
 :create-new-form-success
 (fn [ds [_ workspace-id folder-id data]]
   (let [token (get-token)] 
     (.setItem (.-localStorage js/window) "tenant_id" workspace-id)
     (js/window.location.assign (str strive-react-endpoint "/strive-forms/" (:form-id data)
                                     "?token=" token
                                     "&workspace_id=" workspace-id
                                     (when-not (nil? folder-id) (str "&folder-id=" folder-id)))))))

(reg-event-db
 :create-new-product-success
 (fn [ds [_ workspace-id folder-id data]]
   (let [token (get-token)] 
     (.setItem (.-localStorage js/window) "tenant_id" workspace-id)
     (js/window.location.assign (str strive-react-endpoint "/main?template_id=" (:product-template-id data)
                                     "&token=" token
                                     "&workspace_id=" workspace-id
                                     (when-not (nil? folder-id) (str "&folder-id=" folder-id)))))))
(reg-event-db
 :connected
 (fn [db [_ value]]
   (assoc-in db [:example :connected] value)))

(defn copy-link [link]
  (.writeText js/navigator.clipboard link))

(defn move-multiple-assets [w-id folder-id assets-selected move-notification destination-folder-id]
  (dispatch [::move-multiple  {:workspace-id w-id :folder-id folder-id :asset-ids @assets-selected :destination-folder-id destination-folder-id}])
  (reset! move-notification true))

(defn copy-multiple-assets [w-id folder-id assets-selected copy-notification destination-folder-id]
  (dispatch [::copy-multiple  {:workspace-id w-id :folder-id folder-id :asset-ids @assets-selected :destination-folder-id destination-folder-id}])
  (reset! copy-notification true))

(defn delete-multiple-assets [w-id folder-id assets-selected delete-notification]
  (dispatch [::delete-multiple  {:workspace-id w-id :folder-id folder-id :asset-ids @assets-selected}])
  (reset! delete-notification true))

